<template>
  <div class="space-y-6">
    <h3>About {{ connection.name }}</h3>
    <div>
      <p class="mb-2">Bio</p>
      <div
        class="flex flex-col w-full space-y-4 max-h-[200px] pr-8 overflow-y-scroll"
      >
        <p
          v-for="(sentence, i) in descriptionArray"
          :key="i"
          class="text-truegray-500"
        >
          {{ sentence }}
        </p>
      </div>
    </div>

    <div v-if="connection.organisation" class="my-8">
      <AuthorBadge
        class="mb-6"
        :entity="connection.organisation"
        :context="'connections'"
      />
    </div>

    <div v-if="connection.tags_organisations.length">
      <p class="mb-2">Career support areas</p>
      <div class="flex flex-wrap gap-x-4 gap-y-2">
        <div
          v-for="(item, i) in connection.tags_organisations"
          :key="i"
          class="px-2 py-1 border text-sm rounded-xl"
          :class="
            isContributor
              ? 'border-cw-alt text-cw-alt'
              : 'border-primary text-primary'
          "
        >
          {{ getTagDisplayTitle(item, connection.additional_info) }}
        </div>
      </div>
    </div>

    <div v-if="connection.tags_preferences.length">
      <p class="mb-2">Preferences</p>
      <div class="flex flex-wrap gap-x-4 gap-y-2">
        <div
          v-for="(item, i) in connection.tags_preferences"
          :key="i"
          class="px-2 py-1 border text-sm rounded-xl"
          :class="
            isContributor
              ? 'border-cw-alt text-cw-alt'
              : 'border-primary text-primary'
          "
        >
          {{ getTagDisplayTitle(item, connection.additional_info) }}
        </div>
      </div>
    </div>

    <div v-if="connection.tags_school_support.length">
      <p class="mb-2">School Support</p>
      <div class="flex flex-wrap gap-x-4 gap-y-2">
        <div
          v-for="(item, i) in connection.tags_school_support"
          :key="i"
          class="px-2 py-1 border text-sm rounded-xl"
          :class="
            isContributor
              ? 'border-cw-alt text-cw-alt'
              : 'border-primary text-primary'
          "
        >
          {{ item.title }}
        </div>
      </div>
    </div>

    <div v-if="connection.tags_industries">
      <p class="mb-2">Industries</p>
      <div class="flex flex-wrap gap-x-4 gap-y-2">
        <div
          v-for="(item, i) in connection.tags_industries"
          :key="i"
          class="py-1 px-2 bg-truegray-100 text-xs rounded-xl"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref, onMounted } from 'vue'
import { useStore } from '../../../../../js/store/index.js'
import { getTagDisplayTitle } from '../../../../../js/util/helper.js'
import AuthorBadge from '../../../../tenant/manager/pages/cloud/AuthorBadge.vue'

export default defineComponent({
  name: 'ModalProfileBio',
  components: { AuthorBadge },

  props: {
    connection: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const store = useStore()
    const isContributor = computed(() => store.getters['shared/isContributor'])
    const descriptionArray = ref([])

    onMounted(() => {
      const sentences = props.connection.description.split('. ')
      descriptionArray.value = sentences.map((sentence, index) => {
        // Only add a full stop if it's not the last sentence
        return index !== sentences.length - 1 ? sentence + '.' : sentence
      })
    })

    return { isContributor, getTagDisplayTitle, descriptionArray }
  },
})
</script>
